import React, { useState, useEffect } from 'react'
import api from "../api/api.list"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

toast.configure()

function Card({ getlist, getCount }) {
    const [mrnumber, setMrNumber] = useState('')
    const [name, setName] = useState('')
    const [insurance, setInsurance] = useState('')
    const [visitdate, setVisitDate] = useState('')
    const [requestdate, setRequestDate] = useState('')
    const [drname, setDrName] = useState('')
    const [remarks, setRemarks] = useState('')


   
      

    return (

        <div class="col-md-12">
            <div class="card">
                <div class="header">
                     <h5 class="title">Enter request details</h5>
                </div>
                <div class="content table-responsive table-full-width">
                    <card class=" table-striped">
                        <thead>
                            <tr>
                                <th>Mr Number</th>
                                <th>Name</th>
                                <th>Insurance</th>
                                <th>Visit Date</th>
                                <th>Request Received </th>
                                <th>Dr.Name/Order</th>
                                {/* <th>Remarks</th> */}
                                <td></td>
                            </tr></thead>
                        <tbody>

                            <tr>
                                {/* < onChange={date => setVisitDate(date)} />
                            < onChange={date => setRequestDate(date)} /> */}
                                <td><input type="text" name="mrnumber" value={mrnumber} autoComplete="off" onChange={(e) => {
                                    setMrNumber(e.target.value)
                                }}
                                    class="form-control border-input" /></td>
                                    <td><input type="text" name="name" autoComplete="off" value={name} onChange={(e) => {
                                    setName(e.target.value)
                                }}
                                    class="form-control border-input" /></td>
                                <td><input type="text" name="insurance" autoComplete="off" value={insurance} onChange={(e) => {
                                    setInsurance(e.target.value)

                                }}
                                    class="form-control border-input" /></td>
                                <td>
                                <div class="form-control border-input">
                                    <DatePicker selected={visitdate} autoComplete="off" name="visitdate" dateFormat="MMM d, yyyy" value={visitdate} onChange={(e) => {
                                    setVisitDate(e)
                                }}
                                    class="form-control border-input" />
                                    </div>
                                    </td>
                                <td>
                                <div class="form-control border-input">
                                    <DatePicker selected={requestdate} autoComplete="off" showTimeSelect dateFormat="MMM d, yyyy h:mm aa" timeIntervals={1} name="requestdate" value={requestdate} onChange={(e) => {
                                    setRequestDate(e)
                                }}
                                    class="form-control border-input" />
                                    </div>
                                    </td>
                                <td>
                                    <input type="text" name="drname" autoComplete="off" value={drname} onChange={(e) => {
                                        setDrName(e.target.value)
                                    }}
                                        class="form-control border-input" /></td>
                                {/* <td><input type="text" name="remarks" value={remarks} onChange={(e) => {
                                    setRemarks(e.target.value)
                                }}
                                class="input-txt-box"  /></td> */}


                                <th>
                                    <td>
                                        <input class="input-submit" type="Submit" name="Submit"
                                            style={{ 'border': '1px solid black' }} onClick={() => {
                                                let data = {
                                                    "mrnumber": mrnumber.indexOf("AEMC") == -1 ? "AEMC" + mrnumber : mrnumber,
                                                    "name": name,
                                                    "insurance": insurance,
                                                    "requestdate": requestdate,
                                                    "visitdate": visitdate,
                                                    "drname": drname.indexOf("DR.") == -1 ? "DR." + drname : drname,
                                                    //"drname": drname,
                                                    "approvalstatus": '0',
                                                    "remarks": "",
                                                    "approvalid": "",
                                                    "orderingclinicianid": "",
                                                    "authorizationdate": null,
                                                    "createdby": localStorage.userid
                                                }
                                                
                                                api.savelist(data).then(res => {
                                                    toast('Sucessfully Saved')
                                                    getlist()
                                                    setMrNumber('')
                                                    setName('')
                                                    setInsurance('')
                                                    setRequestDate('')
                                                    setVisitDate('')
                                                    setDrName('')
                                                    setRemarks('')
                                                    getCount()
                                                    //console.log(res.data)
                                                })

                                            }} />
                                    </td>
                                </th>
                            </tr>
                        </tbody>

                    </card>

                </div>
            </div>
        </div>
    )

}
export default Card